import React, { useContext } from 'react';
import { useAtom } from 'jotai';

import { customTravelFormStateAtom } from '@/atoms/customTravelFormState';
import SelectDurationForm from '@/components/CustomTravel/ServiceForm/forms/SelectDurationForm';
import { CustomInitContext } from '@/components/CustomTravel/CustomInit';

interface SelectDurationProps {}

const SelectDuration: React.FC<SelectDurationProps> = () => {
  const [{ tourSchedule }] = useAtom(customTravelFormStateAtom);
  const { overseasProduct } = useContext(CustomInitContext);

  const defaultValues =
    overseasProduct?.beginDate && overseasProduct?.endDate
      ? { tourSchedule: { schedules: [{ from: overseasProduct.beginDate, to: overseasProduct.endDate }] } }
      : undefined;

  return <SelectDurationForm externalValues={tourSchedule ? { tourSchedule } : defaultValues} />;
};

export default SelectDuration;
